module.exports = "/_next/static/resources/ya-wide-c9e37ea34798e502104d5991bac39456.png";